module.exports = __webpack_public_path__ + "img/notviewiconn.fca396d1.svg";